import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Row, Col, Form, Button, ListGroup } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { getAppliedFilterData, validateDatefilter } from './helper';
import { FilterFormCheckbox, FilterFormZoneCheckbox } from './filterformCheckbox';
import { DATE_FORMAT, DELIVERY_DATE_FORMAT } from '../../../constants';
// import * as PortfolioConstants from '../constants';
class FilterForm extends Component {
    constructor() {
        super();
        this.state = {
            toDate: null,
            fromDate: null,
            appliedFilters: [],
            moreFilter: false,
            errorMessage: ''
        }
    }
    componentDidUpdate(prevProps) {
        const { clearAll, filterForm } = this.props
        if (filterForm !== prevProps.filterForm && this.props.filterForm['values']) {
            const tempFilterFormValues = Object.entries(filterForm.values).filter(value => value[1] === true).map(key => key[0]);
            const tempCounterPartyData = tempFilterFormValues.filter(value => this.props.counterPartyData.indexOf(value) !== -1)
            const tempZoneList = tempFilterFormValues.filter(value => this.props.zoneList.map(p => p.name).indexOf(value) !== -1)
            const tempRiskLevel = tempFilterFormValues.filter(value => this.props.riskLevel.indexOf(value) !== -1);
            const tempReportType = tempFilterFormValues.filter(value => this.props.reportType.indexOf(value) !== -1);
            const tempRiskTrend = tempFilterFormValues.filter(value => this.props.riskTrend.indexOf(value) !== -1);
            const tempCaseStatus = tempFilterFormValues.filter(value => this.props.caseStatus.indexOf(value) !== -1);
            const tempLegalConstitution = tempFilterFormValues.filter(value => this.props.legalConstitution.indexOf(value) !== -1);
            const tempBusinessSegment = tempFilterFormValues.filter(value => this.props.businessSegment.indexOf(value) !== -1);
            this.setState({
                appliedFilters: getAppliedFilterData(tempCounterPartyData, tempZoneList, tempRiskLevel, tempReportType, tempRiskTrend, tempLegalConstitution, tempBusinessSegment, tempCaseStatus)
            });
        }
        if (clearAll !== prevProps.clearAll) {
            this.resetPortfolioFilters()
        } else if (this.props.toDate !== prevProps.toDate) {
            this.setState({
                toDate: this.props.toDate,
                fromDate: this.props.fromDate
            })
        } else if (this.props.fromDate !== prevProps.fromDate) {
            this.setState({
                toDate: this.props.toDate,
                fromDate: this.props.fromDate
            })
        }
    }
    applyPortfolioFilters = () => {
        const validateDate = validateDatefilter(this.state.toDate, this.state.fromDate);
        if (validateDate) {
            this.setState({
                errorMessage: ''
            })
            this.props.filterFormCallback(this.state.appliedFilters, this.state.toDate, this.state.fromDate)
        } else {
            this.setState({
                errorMessage: 'Both date fields are mandatory'
            })
        }

    }
    hidePortfolioFilters = () => {
        this.props.hidePortfolioFiltersCallback()
    }
    resetPortfolioFilters = () => {
        this.props.filterFormCallback()
        this.props.reset();
        this.setState({
            toDate: null,
            fromDate: null
        })
    }
    handleFromDateChange = (date) => {
        this.setState({ fromDate: date })
    }
    handleToDateChange = (date) => {
        this.setState({ toDate: date })
    }
    showMoreFilters = () => {
        this.setState({ moreFilter: !this.state.moreFilter })
    }
    render() {
        return (
            <Form>
                <Row noGutters className="mb-4">
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Counterparty Type<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.counterPartyData.map(counterPartyCheckboxData => {
                                return (
                                    <FilterFormCheckbox key={counterPartyCheckboxData} checkboxData={counterPartyCheckboxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Report Type<i className="icon-plus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.reportType.map(reportTypeCheckboxData => {
                                return (
                                    <FilterFormCheckbox key={reportTypeCheckboxData} checkboxData={reportTypeCheckboxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                    <Col sm="4" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Risk Level<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.riskLevel.map(riskLevelCheckboxData => {
                                return (
                                    <FilterFormCheckbox key={riskLevelCheckboxData} checkboxData={riskLevelCheckboxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Region<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.zoneList.map(zoneListCheckboxData => {
                                return (
                                    <FilterFormZoneCheckbox key={zoneListCheckboxData.id} zoneListCheckboxData={zoneListCheckboxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                    <Col sm="5" className="filter-category p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Class of Company<i className="icon-minus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {this.props.legalConstitution.map(legalConstitutionCheckBoxData => {
                                return (
                                    <FilterFormCheckbox key={legalConstitutionCheckBoxData} checkboxData={legalConstitutionCheckBoxData} />
                                )
                            })}
                        </ListGroup>
                    </Col>
                </Row>
                {this.state.moreFilter && (
                    <Row noGutters className="mb-3">
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Business Segment<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.businessSegment.map(businessSegmentCheckboxData => {
                                    return (
                                        <FilterFormCheckbox key={businessSegmentCheckboxData} checkboxData={businessSegmentCheckboxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Case Status<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.caseStatus.map(caseStatusCheckBoxData => {
                                    return (
                                        <FilterFormCheckbox key={caseStatusCheckBoxData} checkboxData={caseStatusCheckBoxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        <Col sm="4" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Risk Trend<i className="icon-minus d-sm-none"></i></span>
                            <ListGroup className="filter-options">
                                {this.props.riskTrend.map(riskTrendCheckBoxData => {
                                    return (
                                        <FilterFormCheckbox key={riskTrendCheckBoxData} checkboxData={riskTrendCheckBoxData} />
                                    )
                                })}
                            </ListGroup>
                        </Col>
                        <Col sm="5" className="filter-category p-3 py-sm-0">
                            <span className="filter-popover-header-item d-flex justify-content-between">Delivery Date Range<i className="icon-minus d-sm-none"></i></span>
                            <div className="filter-options">
                                <div name="fromDate" className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">From</span> <DatePicker className="mb-2 ml-1" selected={this.state.fromDate} placeholderText={DATE_FORMAT} onChange={this.handleFromDateChange} dateFormat={DELIVERY_DATE_FORMAT} /></div>
                                <div className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">To</span> <DatePicker className="ml-1" selected={this.state.toDate} placeholderText={DATE_FORMAT} onChange={this.handleToDateChange} dateFormat={DELIVERY_DATE_FORMAT} /></div>
                            </div>
                            <span className="text-danger">{this.state.errorMessage}</span>
                        </Col>
                    </Row>)}
                <Row>
                    <Col className="d-flex flex-column flex-sm-row justify-content-sm-between">
                        <div className="mb-3 mb-sm-0 d-flex justify-content-between">
                            <Button className="px-3" outline color="primary" onClick={this.showMoreFilters}>{this.state.moreFilter ? 'Hide Filters' : 'Advance Filters'}</Button>
                            {/*<Button className="px-3 ml-2" outline color="primary" onClick={this.hidePortfolioFilters}>Hide Filters</Button>*/}
                            <Button className="px-3 ml-2" outline color="primary" onClick={this.resetPortfolioFilters}>Reset</Button>
                        </div>

                        <Button color="primary" onClick={this.applyPortfolioFilters}>Apply</Button>
                    </Col>
                </Row>
            </Form >
        )
    }
}
FilterForm = reduxForm({
    form: 'filterform',
    enableReinitialize: true
})(FilterForm)

const mapStateToProps = (state, ownProps) => ({
    filterForm: state.form.filterform,
    filterformData: state.form.filterform
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default FilterForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterForm)
